import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import SectionCard from "../../components/Admin/ApplicationView/SectionCard";
import KeyValueGrid from "../../components/Admin/ApplicationView/KeyValueGrid";
import { mapFieldsToValues, scriptRegex } from "../../utils/utils";
import api from "../../api/ApiService";
import { userDetailViewSections } from "../../forms/userDetailFields";
import Button from "../../components/common/Button";
import { nodalOfficersRoleMap } from "../../config/roleConfig";
import { Spinner } from "../../icons/CommonIcons";
import Message from "../../components/common/Message";

const UserDetails = () => {
  const [formData, setFormData] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const [remarks, setRemarks] = useState("");
  const [updating, setUpdating] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [apiMessage, setApiMessage] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      const [automaticDataResponse, manualDataResponse, userFullDataResponse] =
        await Promise.all([
          api.get(`/admin/automatic-data/${location.state.data.caf_id}`),
          api.get(`/admin/manual-data/${location.state.data.caf_id}`),
          api.get("/user-full-data"),
        ]);

      setFormData({
        ...automaticDataResponse,
        ...JSON.parse(manualDataResponse.details),
      });
      setUserDetails(userFullDataResponse?.data?.user_details || {});
      setRemarks(
        location.state.data?.dtdo_remarks
          ? location.state.data.dtdo_remarks === "N/A"
            ? ""
            : location.state.data.dtdo_remarks
          : "",
      );
    };
    fetchData();
  }, []);

  const handleUpdateRemarks = async () => {
    try {
      if (!remarks)
        return setApiMessage({
          type: "error",
          message: "Remarks cannot be empty",
        });
      setUpdating(true);
      await api.post("/admin/invest-uk/update-dtdo-remarks", {
        caf_id: location.state.data.caf_id,
        remarks,
      });
      setUpdating(false);
      setApiMessage({
        type: "success",
        message: "Remarks updated successfully",
      });
    } catch (err) {
      setUpdating(false);
      setApiMessage({
        type: "error",
        message: err.response?.data?.message || "Failed to update remarks",
      });
    }
  };

  return (
    <DashboardLayout pageTitle="Profile" mainClass="p-6">
      <div className="flex justify-end mb-4">
        <Button
          className="bg-btn font-semibold py-2 px-4 rounded-md"
          onClick={() => navigate("/admin/registered-users")}
        >
          Back
        </Button>
      </div>
      <div className="bg-white rounded p-3">
        {userDetailViewSections.map((section, index) => (
          <SectionCard key={index} title={section.title} color="blue">
            <KeyValueGrid data={mapFieldsToValues(section.fields, formData)} />
            {section.subSections?.map((sub, subIndex) => {
              const fields = sub.fields;
              return (
                <div
                  key={subIndex}
                  className="mt-6 border border-gray-200 rounded p-4 bg-gray-50"
                >
                  {sub.title && (
                    <h4 className="font-bold text-theme-color mb-3 text-xl">
                      {sub.title}
                    </h4>
                  )}

                  {fields?.length > 0 && (
                    <KeyValueGrid data={mapFieldsToValues(fields, formData)} />
                  )}
                </div>
              );
            })}
          </SectionCard>
        ))}
        {String(userDetails?.role_id) === nodalOfficersRoleMap.dlct.value ? (
          <SectionCard title="Update Remarks" color="blue">
            <div className="mt-4">
              {apiMessage && (
                <Message
                  apiMessage={apiMessage}
                  setApiMessage={setApiMessage}
                />
              )}
            </div>
            <div className="space-y-4">
              <div>
                <label
                  htmlFor="remarks"
                  className="block font-medium text-gray-700"
                >
                  DTDO Remarks
                </label>
                <textarea
                  id="remarks"
                  value={remarks}
                  onChange={(e) => {
                    if (!scriptRegex.test(e.target.value)) {
                      setRemarks(e.target.value);
                    }
                  }}
                  className="mt-1 block w-full border border-gray-300 rounded px-3 py-2 text-sm"
                ></textarea>
              </div>
              {updating ? (
                <Button className="px-4 py-2 rounded bg-btn text-white flex items-center justify-center gap-2">
                  Updating
                  <Spinner />
                </Button>
              ) : (
                <button
                  onClick={handleUpdateRemarks}
                  className="px-4 py-2 rounded bg-btn text-white"
                >
                  Update
                </button>
              )}
            </div>
          </SectionCard>
        ) : null}
      </div>
    </DashboardLayout>
  );
};

export default UserDetails;
